const locales = {
  en: { enabled: true, default: true, nativeName: "English" },
  es: { enabled: true, default: false, nativeName: "Español" },
  eu: { enabled: false, default: false, nativeName: "Euskara" },
  ca: { enabled: false, default: false, nativeName: "Català" },
  de: { enabled: false, default: false, nativeName: "Deutsch" },
  fr: { enabled: false, default: false, nativeName: "Français" },
  it: { enabled: false, default: false, nativeName: "Italiano" },
  nl: { enabled: false, default: false, nativeName: "Nederlands" },
  no: { enabled: false, default: false, nativeName: "Norsk" },
  pl: { enabled: false, default: false, nativeName: "Polski" },
  pt: { enabled: false, default: false, nativeName: "Português" },
  ru: { enabled: false, default: false, nativeName: "Ру́сский" },
}

export default locales
